export default function BackgroundPages() {
  return <div className="apply-trial-hero-bg" aria-hidden="true" />;
}
